import buildApiRouter from "@mpa/toolbox/api/buildApiRouter";
import EndpointRouter from "@mpa/toolbox/endpoint/EndpointRouter";
const api = buildApiRouter(new EndpointRouter());
export { api };
